import { render, staticRenderFns } from "./AppMarkdownEditor.vue?vue&type=template&id=2d6641e2&scoped=true&"
import script from "./AppMarkdownEditor.vue?vue&type=script&lang=ts&"
export * from "./AppMarkdownEditor.vue?vue&type=script&lang=ts&"
import style0 from "./AppMarkdownEditor.vue?vue&type=style&index=0&id=2d6641e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6641e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
